import {
  Component,
  OnInit,
  ViewChild,
  AfterContentInit,
  Input,
  ViewEncapsulation
} from "@angular/core";
import { INDEX_OF_DASH } from "../../shared/const";
import { SidePanelService } from "../../features/side-panel/side-panel.service";
import { FilterOptionService } from "app/features/filter-options/filter-options.service";
import { DataInteraction } from "app/shared/data-interaction";
import { KpiComponent } from "app/features/kpi/kpi.component";
import { ChartsComponent } from "app/features/charts/charts.component";
import { DashSelectionService } from "app/shared/services/dash-selection.service";
import { Subject, Observable } from "rxjs";
import { DataCollectionService } from "app/shared/services/data-collection.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit {
  selectedDashboard$: Observable<String>;
  availableDashboards$: Observable<String[]>;
  private availableDashboards2;
  private _dataFilters: DataInteraction;
  private _indexOfSelectedDashboard;
  private dashboard_id: String;
  private configData;
  private indexOfDashboards = INDEX_OF_DASH;

  constructor(
    private dataCollectionService: DataCollectionService,
    private panelService: SidePanelService,
    private filterOptionService: FilterOptionService,
    private dashSelectionService: DashSelectionService
  ) {
    this.availableDashboards$ = dashSelectionService.getAvailableDashboard();
    this.selectedDashboard$ = dashSelectionService.getSelectedDashboard();
    this.filterOptionService.getDataFilters().subscribe(data => {
      if (data) {
        this._dataFilters = Object.assign({}, data);
      }
    });
  }

  ngOnInit(): void {
    // read configuration file
    this.dataCollectionService.getConfigFile().then(configData => {
      // save configuration file in component
      this.configData = configData;
    });
  }

  get dataFilters() {
    return this._dataFilters;
  }

  onTabChanged(event) {
    this.availableDashboards2 = this.dashSelectionService.getAvailableDashboard2();
    this._indexOfSelectedDashboard = event.index;
    this.dashboard_id = this.dashboardLabelToId(this._indexOfSelectedDashboard);
    this.dashSelectionService.setNewDashboard(this.dashboard_id);
  }
  
  dashboardLabelToId(labelToTranslate) {
    // var idOfSelectedDashboard = this.indexOfDashboards[labelToTranslate];
    var idOfSelectedDashboard = this.availableDashboards2[labelToTranslate];
    return idOfSelectedDashboard;
    // var pairValues = {
    //   "Publique": "public",
    //   "Général": "public",
    //   "Energie des bâtiments": "energie_batiments",
    //   "Chaleur": "heat",
    //   "Electricité": "electricity",
    //   "Réseaux thermiques": "dhn",
    //   "Production renouvelable": "renewable_production",
    //   "Production d’électricité renouvelable": "elec_renewable_prod",
    //   "Réseaux": "networks",
    //   "Mobilité": "mobility",
    //   "Véhicules": "vehicles",
    //   "Subventions": "subsidies",
    //   "Actions sur le territoire": "actions",
    //   "Bâtiments communaux": "patrimony",
    //   "Minergie": "minergie",
    //   "Pistes cyclables": "cycling_path",
    //   "Stationnement": "parking_spaces",
    //   "Démo": "demo",
    //   "Valeurs cibles": "target_values",
    //   "Bilan GES": "co2",
    //   "Emissions CO2": "co2_emissions",
    //   "Rénovation du parc bâti et nouvelles constructions": "renovation",
    //   "Objectifs de la SE 2035": "objectives_2035",
    //   "Transition du gaz naturel vers le gaz renouvelable": "gas",
    //   "Développement et raccordement à des réseaux thermiques":
    //     "dhn_connections",
    //   "Mobilité individuelle motorisée ": "individual_motorised_mobility",
    //   "Développement de la production électrique renouvelable":
    //     "elec_prod_development",
    //   "Remplacement de chaudières fossiles et du chauffage électrique en faveur de l’énergie renouvelable":
    //     "fossil_replacement",
    //   "Mobilité individuelle motorisée": "individual_mobility_motorised",
    //   "Bilan GES 2000W": "co2_2kw",
    //   "Bilan GES PDi": "co2_pdi",
    //   "Electricité PDi": "electricity_pdi",
    //   "Chaleur PDi": "heat_pdi",
    //   "Objectifs Société 2000W": "s2000w"
    // };
  }
}
